var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('transition',{attrs:{"name":_vm.Transition,"mode":"out-in","enter-active-class":(_vm.Transition + "-enter-active")},on:{"beforeLeave":_vm.beforeLeave,"enter":_vm.enter,"afterEnter":_vm.afterEnter}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }